import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Space, Button, Row, Col, Typography } from 'antd';
import AddForm from '../components/AddForm';
import { getStockTemplateOption } from '../../ducks/actions'
import { addStockTemplate } from "../../ducks/services"
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'Translate';

const _ = require('lodash');
const { Title } = Typography;

export default (props) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const meta = useSelector((state) => state.inventory.stockTemplateOption);
  const i18n = useTranslate();
    const { t } = i18n;

  useEffect(() => {
    dispatch(getStockTemplateOption(props.setLoading));
  }, [])

  return (
    <Row gutter={[20, 30]}>
      <Col span={24} style={{ position: "sticky", top: "-30px", backgroundColor: "#f5f5f5", zIndex: 3, padding: "10px" }}>
        <Row justify={'space-between'} align={'middle'}>
          <Col flex='auto'>
            <Title level={3} className='mb-0 mt-0'>{t("New.stock_template")}</Title>
          </Col>
          <Col flex='auto' className='text-right'>
            <Space size={10}>
              <Button size="large" htmlType='button' className='red-btn text-white' onClick={() => navigate('/inventory/stock-template')}>{'<'} {t("General.back")}</Button>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <AddForm
          loading={props.loading}
          setLoading={props.setLoading}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          oneTab={true}
          mode={'add'}
          meta={meta}
          addStockTemplate={addStockTemplate}
          navigate={navigate}
          reloadApi={(propId) => navigate(`/inventory/stock-template/${propId}`)}
          allowedEdit={true}
        />
      </Col>
    </Row>
  )
}